<template>
  <AdminConfirmModal
    v-model="getDeclineTestModal"
    :message="$t('Tariffs.sure_want_decline')"
    :confirm-text="$t('Default.accept')"
    @confirm="declineTest"
  />
</template>
<script>
import { ref } from "@vue/composition-api";
import { DispatchTypes, MutationTypes } from "@/store/modules/tests/types";
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import { globalVariables } from "@/utility/variables";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  props: ["currentTestInfo"],
  setup(props) {
    const store = useStore();

    const { userInfo } = globalVariables();

    const getDeclineTestModal = shortComputed(
      {
        storeType: "tests",
        key: "getDeclineTestModal",
      },
      MutationTypes.setDeclineTestModal
    );

    const payload = ref({
      status: 3,
    });

    const declineTest = () => {
      store
        .dispatch(DispatchTypes.changeTestApplication, {
          id: props.currentTestInfo.id + "/",
          payload: payload.value,
        })
        .then(() => {
          store.commit(MutationTypes.setDeclineTestModal, false);
          store.dispatch(DispatchTypes.getTestApplication, "?status=" + 1);
        });
    };

    return {
      store,
      getDeclineTestModal,
      declineTest,
      userInfo,
      payload,
    };
  },
};
</script>
